import React from 'react';
import styled from 'styled-components';

const CartCountChartWrapper = styled.div`
  display: flex;
  align-items: center;

  .label {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #45494D;
    width: fit-content;
    min-width: 20ch;
  }

  .progress-rail {
    width: 100%;
  }

  .progress {
    // height: 16px;
    transition: width 0.5s ease-out;
  }
  
  .count {
    display: inline-block;
    padding: 8px 16px;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #FFFFFF;
  }
`;

const CartCountChart = ({ label, count, total, color = '#979899', ...rest }) => {
  const percentage = total ? Math.round((count * 100) / total) : 0;

  return (
    <CartCountChartWrapper {...rest}>
      <span className="label">{label}</span>
      <div className="progress-rail">
        <div className="progress" style={{ backgroundColor: color, width: `${percentage}%` }}>
          <span className="count">
            {count}
          </span>
        </div>
      </div>
    </CartCountChartWrapper>
  );
};

export default CartCountChart;